module.exports = __webpack_public_path__ + "static/media/dyami.e7d2f5f8.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/dyami.webp
// module id = 251
// module chunks = 0